var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65.369,
    height: 65.37,
    viewBox: "0 0 65.369 65.37",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M545.94,1072.122a32.685,32.685,0,1,0,32.685,32.685A32.666,32.666,0,0,0,545.94,1072.122Zm17.3,23.757-20.94,20.939a2.18,2.18,0,0,1-3.082,0l-10.582-10.583a2.179,2.179,0,0,1,3.081-3.082l9.042,9.042,19.4-19.4a2.179,2.179,0,0,1,3.082,3.081Z",
    transform: "translate(-513.255 -1072.122)",
    fill: "#91dc1b"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NS4zNjkiIGhlaWdodD0iNjUuMzciIHZpZXdCb3g9IjAgMCA2NS4zNjkgNjUuMzciPgogIDxwYXRoIGlkPSJQYXRoXzYzNiIgZGF0YS1uYW1lPSJQYXRoIDYzNiIgZD0iTTU0NS45NCwxMDcyLjEyMmEzMi42ODUsMzIuNjg1LDAsMSwwLDMyLjY4NSwzMi42ODVBMzIuNjY2LDMyLjY2NiwwLDAsMCw1NDUuOTQsMTA3Mi4xMjJabTE3LjMsMjMuNzU3LTIwLjk0LDIwLjkzOWEyLjE4LDIuMTgsMCwwLDEtMy4wODIsMGwtMTAuNTgyLTEwLjU4M2EyLjE3OSwyLjE3OSwwLDAsMSwzLjA4MS0zLjA4Mmw5LjA0Miw5LjA0MiwxOS40LTE5LjRhMi4xNzksMi4xNzksMCwwLDEsMy4wODIsMy4wODFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTEzLjI1NSAtMTA3Mi4xMjIpIiBmaWxsPSIjOTFkYzFiIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };